var _rect, _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path0, _path1, _g2, _path10, _path11, _path12, _rect2, _path13, _path14, _circle, _rect3, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadFilterCombination(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 91,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 111.151,
    width: 22.355,
    height: 22.355,
    rx: 11.178,
    fill: "#FBDBDF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.583 16.393l-2.235.745v-6.333l-3.338-3.673a1.487 1.487 0 01-.388-1.002V4.47h11.923v1.62c0 .394-.157.773-.437 1.053l-3.289 3.289v1.118m1.49 5.588l2.981-2.98m-3.726 1.49a2.237 2.237 0 004.471 0 2.232 2.232 0 00-2.235-2.235 2.235 2.235 0 00-2.236 2.235z",
    stroke: "#D0021B",
    strokeWidth: 1.118,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.028 81.762l13.799-19.366a15.527 15.527 0 0116.896-5.913l23.59 6.723a15.524 15.524 0 018.473 6.047l3.164 12.509H53.028z",
    fill: "#F8C6D2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113.814 66.366H63.088l7.991-38.897h34.744l7.991 38.897z",
    fill: "#2C3543"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.455 73.123a6.45 6.45 0 01-6.448-6.447V49.737h12.895v16.939a6.45 6.45 0 01-6.447 6.447z",
    fill: "#CC8062"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "bad_filter_combination_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 82,
    y: 49,
    width: 13,
    height: 25
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.456 73.123a6.45 6.45 0 01-6.448-6.447V49.737h12.895v16.939a6.45 6.45 0 01-6.447 6.447z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bad_filter_combination_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.432 63.749a21.492 21.492 0 01-6.138-.338c-6.646-1.294-11.462-9.484-11.02-13.13l16.284-1.676s.668 11.483.874 15.151v-.007z",
    fill: "#AC6818",
    opacity: 0.5
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M97.207 47.003h5.11a3.292 3.292 0 100-6.587h-5.11",
    fill: "#CC8062"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.663 45.319a1.618 1.618 0 100-3.235",
    stroke: "#8E473D",
    strokeWidth: 1.334,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79.698 47.003h-5.11a3.293 3.293 0 110-6.587h5.11",
    fill: "#CC8062"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74.242 45.319a1.617 1.617 0 010-3.235",
    stroke: "#8E473D",
    strokeWidth: 1.334,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M76.176 26.682h24.555v20.07c0 6.778-5.5 12.277-12.278 12.277-6.778 0-12.277-5.5-12.277-12.277v-20.07z",
    fill: "#CC8062"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "bad_filter_combination_svg__b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 70,
    y: 13,
    width: 37,
    height: 37
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M88.38 49.569c9.985 0 18.078-8.094 18.078-18.078s-8.093-18.078-18.077-18.078c-9.984 0-18.078 8.094-18.078 18.078s8.094 18.078 18.078 18.078z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bad_filter_combination_svg__b)",
    fill: "#2C3543"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.663 40.57c10.029 0 18.159-8.13 18.159-18.158 0-10.03-8.13-18.16-18.159-18.16-10.029 0-18.159 8.13-18.159 18.16 0 10.028 8.13 18.158 18.159 18.158z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.242 34.688c6.98 0 12.637-5.658 12.637-12.637 0-6.98-5.658-12.638-12.637-12.638-6.98 0-12.638 5.658-12.638 12.638 0 6.98 5.658 12.637 12.638 12.637z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M80.407 37.799a.72.72 0 00-1.44 0v1.227a.72.72 0 001.44 0V37.8zM91.267 37.799a.72.72 0 00-1.441 0v1.227a.72.72 0 001.441 0V37.8z",
    fill: "#2C3543"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M89.826 35.594h2.551M79.136 35.594h2.55",
    stroke: "#2C3543",
    strokeWidth: 1.334,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M89.227 42.205a3.851 3.851 0 01-4.552 2.993",
    stroke: "#fff",
    strokeWidth: 1.334,
    strokeMiterlimit: 10
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.494,
    y: 47.629,
    width: 59.502,
    height: 18.55,
    rx: 3.71,
    transform: "rotate(-9.31 .494 47.629)",
    fill: "#C3DEF7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.471 58.775l-.836.137-1.178-7.187 4.002-.656.12.737-3.165.52.432 2.634 2.974-.487.12.732-2.974.488.505 3.082zm4.175-6.217l.884 5.388-.816.134-.884-5.388.816-.134zm-.728-1.95a.493.493 0 01.366.076c.112.07.183.195.213.379.03.18.003.323-.081.427a.494.494 0 01-.322.19.506.506 0 01-.376-.075c-.107-.074-.174-.2-.204-.38-.03-.184-.006-.326.072-.427a.506.506 0 01.332-.19zm4.163 6.92l-.82.134-1.255-7.65.821-.134 1.254 7.65zm3.372-1.139a2.616 2.616 0 00.738-.242l.104.634a1.756 1.756 0 01-.38.174 2.86 2.86 0 01-.485.125c-.285.046-.552.04-.8-.02a1.22 1.22 0 01-.645-.42c-.177-.217-.3-.536-.37-.96l-.523-3.195-.767.126-.065-.398.72-.446.132-1.223.492-.08.204 1.248 1.578-.259.105.64-1.578.258.52 3.17c.055.338.174.578.355.72.185.141.407.19.665.148zm3.117-5.559c.46-.075.87-.038 1.23.111a2 2 0 01.893.733c.233.335.39.747.47 1.235l.083.506-3.722.61c.114.631.35 1.087.71 1.368.358.282.815.377 1.369.286.34-.056.637-.137.889-.242.252-.105.509-.241.77-.409l.118.718a4.029 4.029 0 01-.767.398c-.256.1-.567.179-.93.239-.518.084-.988.054-1.409-.093a2.23 2.23 0 01-1.048-.787c-.28-.375-.468-.859-.566-1.452-.095-.58-.08-1.097.044-1.552a2.3 2.3 0 01.664-1.118c.32-.288.72-.472 1.203-.55zm.1.67c-.436.072-.76.271-.972.599-.212.327-.3.75-.266 1.27l2.851-.467a2.333 2.333 0 00-.29-.82 1.203 1.203 0 00-.532-.5c-.219-.105-.483-.132-.79-.082zm5.928-1.658c.108-.018.222-.03.342-.036.12-.01.227-.012.322-.007l.02.774a2.565 2.565 0 00-.612.025 1.48 1.48 0 00-.592.233 1.476 1.476 0 00-.44.456 1.764 1.764 0 00-.243.64 2.24 2.24 0 000 .778l.475 2.89-.821.135-.883-5.388.678-.111.251.978.035-.006c.078-.218.183-.422.313-.611.13-.193.29-.356.48-.488.194-.133.419-.22.675-.262zm9.817 4.025l-1.26-2.136-2.88.472-.506 2.425-.846.139 1.63-7.678.752-.123 3.975 6.759-.865.142zm-1.632-2.838l-1.212-2.128-.146-.274-.2-.396-.171-.33c-.01.14-.025.28-.042.42a11 11 0 01-.095.687l-.483 2.407 2.35-.386z",
    fill: "#1E3F5E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.897 49.266l3.013 2.164a.464.464 0 00.541-.753l-3.013-2.164 2.164-3.014a.464.464 0 00-.753-.54l-2.164 3.013-3.014-2.165a.464.464 0 00-.54.753l3.013 2.165-2.165 3.013a.465.465 0 10.753.541l2.165-3.013z",
    fill: "#3074B7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53.587,
    cy: 21.796,
    fill: "#FBDBDF",
    r: 2.794
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.019,
    y: 57.308,
    width: 59.502,
    height: 18.55,
    rx: 3.71,
    transform: "rotate(15 15.019 57.308)",
    fill: "#DEF0FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.434 71.984l-.818-.22L21.5 64.73l3.917 1.05-.194.721-3.099-.83-.69 2.579 2.91.78-.191.717-2.912-.78-.808 3.017zm6.364-3.947l-1.413 5.274-.798-.214L26 67.823l.799.214zm.14-2.078a.494.494 0 01.301.22c.074.11.087.254.039.434-.047.176-.13.295-.25.356a.493.493 0 01-.372.04.506.506 0 01-.311-.223c-.067-.11-.077-.255-.03-.43.049-.18.129-.3.241-.36a.507.507 0 01.381-.036zm.945 8.02l-.804-.214 2.006-7.488.804.216-2.006 7.487zm3.542.352a2.607 2.607 0 00.772.083l-.167.62a1.754 1.754 0 01-.418.002 2.86 2.86 0 01-.493-.086c-.279-.075-.52-.19-.721-.348a1.22 1.22 0 01-.415-.647c-.072-.27-.052-.612.059-1.026l.838-3.128-.75-.201.104-.39.839-.11.624-1.06.482.128-.328 1.223 1.545.414-.168.625-1.545-.414-.831 3.104c-.089.33-.08.597.027.801.11.205.292.342.546.41zm5.129-3.783c.45.12.807.323 1.075.608.267.284.438.63.512 1.034.074.402.048.841-.08 1.32l-.133.495-3.643-.976c-.156.622-.128 1.135.083 1.538.212.404.588.679 1.13.824.334.09.637.138.91.146.273.008.564-.01.871-.055l-.188.702a4.019 4.019 0 01-.864.047 4.715 4.715 0 01-.945-.165c-.507-.136-.922-.358-1.246-.664a2.23 2.23 0 01-.63-1.15c-.102-.456-.074-.975.081-1.555.152-.568.378-1.034.679-1.397.304-.365.66-.614 1.066-.746.41-.13.85-.133 1.322-.006zm-.185.651c-.427-.114-.804-.065-1.132.146-.329.211-.584.56-.766 1.048l2.791.748c.081-.316.105-.605.073-.868a1.203 1.203 0 00-.28-.673c-.155-.186-.385-.32-.686-.4zm6.084.93c.106.028.215.064.327.108.113.04.212.082.297.126l-.3.713a2.582 2.582 0 00-.568-.23 1.48 1.48 0 00-.636-.03 1.476 1.476 0 00-.589.234c-.183.12-.345.28-.485.484-.14.2-.246.436-.32.708l-.757 2.83-.804-.216 1.413-5.273.664.177-.174.996.034.009c.162-.167.34-.31.538-.429a1.84 1.84 0 01.638-.246c.231-.041.472-.029.722.038zm4.763-.509l1.992.534c.879.235 1.504.544 1.877.926.372.381.473.888.304 1.52a1.724 1.724 0 01-.356.694c-.16.187-.359.325-.596.413-.236.088-.508.12-.814.096l-.013.048c.295.13.544.292.747.484.203.192.34.421.414.688.072.267.061.579-.034.935-.116.433-.315.772-.597 1.016a1.914 1.914 0 01-1.03.452c-.405.052-.858.012-1.359-.122l-2.42-.649 1.885-7.035zm.01 3.236l1.347.361c.612.165 1.063.177 1.351.038.292-.139.49-.402.594-.79.107-.401.043-.728-.192-.98-.232-.251-.654-.459-1.267-.623l-1.212-.325-.622 2.32zm-.185.688l-.705 2.633 1.462.391c.626.168 1.101.165 1.427-.01.326-.177.544-.474.656-.891.072-.266.073-.51.005-.731-.065-.22-.215-.415-.452-.585-.232-.172-.566-.317-1.002-.434l-1.391-.373z",
    fill: "#1E3F5E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.19 79.96l1.855 3.213a.463.463 0 00.803-.463l-1.855-3.213 3.213-1.855a.463.463 0 00-.463-.803l-3.213 1.855-1.856-3.213a.463.463 0 00-.802.463l1.854 3.213-3.213 1.855a.462.462 0 00-.055.775.463.463 0 00.519.028l3.213-1.855z",
    fill: "#3074B7"
  })));
}
export default SvgBadFilterCombination;